// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3w1wJ","resendInfoText":"OnGoingPaymentBox_resendInfoText__2Q5S2"};